import * as LocalStorage from 'store';

import { INVOICE_HAS_PASSED_ONBOARDING_KEY, InvoiceStatus, InvoiceStatusFilter } from 'constants/invoice';
import { Invoice, InvoicePage, InvoiceState } from 'models/invoice';

export const initialState: InvoiceState = {
  errorType: '',
  hasPassedOnboarding: false,
  invoice: initialInvoice(),
  invoicePage: initialInvoicePage(),
  isInvoicePageUpdated: false,
  isLoading: false
};

export function initialInvoice(): Invoice {
  return {
    account: {
      email: '',
      phone: '',
      store: {
        storeAddress: '',
        storeName: '',
        storeUrl: ''
      }
    },
    createdAt: 0,
    id: '',
    items: [{
      name: '',
      price: 0,
      quantity: 1
    }],
    recipient: {
      name: '',
      phone: ''
    },
    status: InvoiceStatus.PENDING,
    total: 0,
    url: ''
  };
}

export function initialInvoicePage(): InvoicePage {
  return {
    content: [],
    page: {
      number: 0,
      size: 0,
      totalElements: 0,
      totalPages: 0
    },
    status: InvoiceStatusFilter.ALL
  };
}

export function appendInvoicePage(newInvoicePage: InvoicePage, oldInvoicePage: InvoicePage) {
  const { content, page, ...rest } = newInvoicePage;
  return {
    content: [...oldInvoicePage.content, ...content],
    page: { ...page, size: oldInvoicePage.page.size + page.size },
    ...rest
  };
}

export function appendInvoiceAtFirstInInvoicePage(invoice: Invoice, invoicePage: InvoicePage) {
  const { content, page, ...rest } = invoicePage;
  const newInvoicePageContent = [invoice, ...content];
  const newPage = { ...page, totalElements: page.totalElements + 1 };
  return { content: newInvoicePageContent, page: newPage, ...rest };
}

export function updateInvoiceFromInvoicePage(invoice: Invoice, invoicePage: InvoicePage) {
  const { content, ...rest } = invoicePage;
  const newInvoicePageContent = content.map((_invoice) => {
    return invoice.id === _invoice.id ? invoice : _invoice;
  });
  return { content: newInvoicePageContent, ...rest };
}

export function removeInvoiceFromInvoicePage(invoice: Invoice, invoicePage: InvoicePage) {
  const { content, page, ...rest } = invoicePage;
  const newInvoicePageContent = content.filter((_invoice) => _invoice.id !== invoice.id);
  const newPage = { ...page, totalElements: page.totalElements - 1 };
  return { content: newInvoicePageContent, page: newPage, ...rest };
}

export function setHasPassedOnboardingInLocalStorage(accountId: number) {
  LocalStorage.set(generateHasPassedOnboardingLocalStorageKey(accountId), true);
}

export function hasPassedOnboardingFromLocalStorage(accountId: number) {
  return !!LocalStorage.get(generateHasPassedOnboardingLocalStorageKey(accountId));
}

function generateHasPassedOnboardingLocalStorageKey(accountId: number) {
  return accountId + '-' + INVOICE_HAS_PASSED_ONBOARDING_KEY;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/invoice.ts